// extracted by mini-css-extract-plugin
export var editButton = "_kg-0";